import { __ } from '@wordpress/i18n';
import { queryClient, queryKeys } from '../../lib/query-client';
import AuthenticationService from '../../service/authentication-service';
import UsersService from '../../service/users-service';
import displayNetworkError from '../../helpers/displayNetworkError';
import handleSuccessAndDisplay from '../../helpers/handleSuccessAndDisplay';

export const makeUserActions = (set, get) => {
    const fetchUserDataImpl = async () => {
        set('userLoading', true);
        set('userError', null);

        try {
            const data = await queryClient.fetchQuery({
                queryKey: queryKeys.userMe,
                queryFn: AuthenticationService.meAsync,
            });

            set('userData', data);
            set('userLoading', false);
        } catch (error) {
            set('userError', error);
            set('userLoading', false);
            displayNetworkError(error);

            if (!error?.handled) {
                throw error;
            }
        }
    };

    const refetchUserDataImpl = async () => {
        await queryClient.invalidateQueries({ queryKey: queryKeys.userMe });
        await fetchUserDataImpl();
    };

    return {
        fetchUserDataImpl,
        refetchUserDataImpl,

        fetchUserData: fetchUserDataImpl,
        refetchUserData: refetchUserDataImpl,

        fetchUserCounters: async () => {
            set('userCountersLoading', true);
            set('userCountersError', null);
            try {
                const data = await UsersService.getUserCountersAsync();
                set('userCounters', data);
            } catch (error) {
                set('userCountersError', error);
                displayNetworkError(error);
            } finally {
                set('userCountersLoading', false);
            }
        },

        updateUser: async (formData) => {
            try {
                await UsersService.putUserAsync(formData);
                handleSuccessAndDisplay(__('Profilo aggiornato!', 'soundbetween'));
                await queryClient.invalidateQueries({ queryKey: queryKeys.userMe });
                await refetchUserDataImpl();
            } catch (error) {
                displayNetworkError(error);
                if (!error?.handled) throw error;
            }
        },

        updateUserPreferences: async (formData) => {
            try {
                await UsersService.putUserPreferencesAsync(formData);
                handleSuccessAndDisplay(__('Preferenze salvate!', 'soundbetween'));
            } catch (error) {
                displayNetworkError(error);
                if (!error?.handled) throw error;
            }
        },
    };
};
